<mat-dialog-content class="mat-typography">
  <div class="payment-content">
    <div class="icon">
      <mat-icon class="error-color">error</mat-icon>
    </div>
    <div class="payment-title">{{ 'Payment.ErrorOccurred' | translate }}</div>
    <div class="message">
      <div class="">
        {{ 'Payment.ErrorMessage' | translate }}
      </div>
      <div class="">
        {{ 'Payment.ErrorPostMessage' | translate }}
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'Buttons.Close' | translate }}
  </button>
</mat-dialog-actions>
